
import axios from "axios"
import IP from "public-ip";
const anonimo={};
anonimo.enviar=async(values)=>{
    const datos={
        id:0,
        email:"consultasturismo@areco.gob.ar",
        content:{
            id_cuerpo:0,
            email:values.email,
            nombre:values.fullname,
            ip:await IP.v4(),
            
            texto:values.texto
            },
            subject:"Turismo Web Consulta",
            id_cuerpo:0
            }
     console.log("Datos");   
     console.log(datos);     
    const urlGet = "https://areco.gob.ar:9527/email/send";
    const res = await axios.post(urlGet,datos)
    .then(response=> {return response.data })
    .catch(error=>{ return error; })
    return res;
}

export default anonimo;